import { render, staticRenderFns } from "./knowledge-study-level.vue?vue&type=template&id=90e757e0&scoped=true"
import script from "./knowledge-study-level.vue?vue&type=script&lang=js"
export * from "./knowledge-study-level.vue?vue&type=script&lang=js"
import style0 from "./knowledge-study-level.vue?vue&type=style&index=0&id=90e757e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e757e0",
  null
  
)

export default component.exports